module.exports = __webpack_public_path__ + "assets/img/icon_canlendar.f0da2bf2.png";